module.exports = __webpack_public_path__ + "static/media/img-topics-sample03.ee7ad089.jpg";